"use strict";

exports.__esModule = true;
exports.AdvancedTimelineValueHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _Timeline = require("../../Timeline/");
var _TimelineValue = require("../TimelineValue");
var _excluded = ["timeline"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Displays a header for TimelineValue.
 */
var AdvancedTimelineValueHeader = exports.AdvancedTimelineValueHeader = function AdvancedTimelineValueHeader(props) {
  var timelines = _react["default"].useContext(_Timeline.AdvancedTimelineContext);
  var timeline = props.timeline,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var timelineDefinitions = timelines.map(function (timeline) {
    return {
      name: timeline.type,
      description: timeline.label,
      label: timeline.label
    };
  });
  var selectedTimeline = timelineDefinitions.find(function (timelineDefinition) {
    return timelineDefinition.name === timeline;
  });
  if (!selectedTimeline) {
    throw new Error("Timeline Not found");
  }
  return /*#__PURE__*/_react["default"].createElement(_TimelineValue.TimelineValueHeader, _extends({}, extra, {
    selectedTimeline: selectedTimeline,
    timelineName: selectedTimeline.name
  }));
};